import { createReducer } from 'deox';
import { produce } from 'immer';

import { login, updateTokens, logout } from './actions';
import { UserState } from './types';

const initialState: UserState = {
  loading: false,
  error: null,
  data: null,
};

export const userReducer = createReducer(initialState, (handleAction) => [
  handleAction(login.request, (state) =>
    produce(state, (draft) => {
      draft.loading = true;
      draft.error = null;
    }),
  ),
  handleAction(login.success, (state, { payload }) =>
    produce(state, (draft) => {
      draft.loading = false;
      draft.data = payload;
    }),
  ),
  handleAction(login.fail, (state, { payload }) =>
    produce(state, (draft) => {
      draft.loading = false;
      draft.error = payload.message;
    }),
  ),
  handleAction(updateTokens, (state, { payload }) =>
    produce(state, (draft) => {
      draft.data!.access = payload.access;
      draft.data!.refresh = payload.refresh;
    }),
  ),
  handleAction(logout, () => ({ ...initialState })),
]);
